/* eslint-disable */
import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import {
  emailTemplateListPath,
  RotaryListUrlQueryParams,
  RotaryListUrlSortField,
  emailTemplatePath,
  RotaryUrlQueryParams
} from "./urls";
import EmailTemplateDetailsComponent from "./views/EmailTemplateDetails";
import EmailTemplateListComponent from "./views/EmailTemplateList";

const RotaryList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: RotaryListUrlQueryParams = asSortParams(
    qs,
    RotaryListUrlSortField
  );

  return <EmailTemplateListComponent params={params} />;
};

// const mailTemplateCreate: React.FC<RouteComponentProps<{}>> = ({ location }) => {
//   const qs = parseQs(location.search.substr(1));
//   const params: RotaryAddUrlQueryParams = qs;
//   return <EmailTemplateCreateComponent params={params} />;
// };

const RotaryDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: RotaryUrlQueryParams = qs;
  return (
    <EmailTemplateDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const emailTemplateSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.rotary)} />
      <Switch>
        <Route exact path={emailTemplateListPath} component={RotaryList} />
        {/* <Route exact path={rotaryAddPath} component={mailTemplateCreate} /> */}
        <Route path={emailTemplatePath(":id")} component={RotaryDetails} />
      </Switch>
    </>
  );
};
export default emailTemplateSection;
